export default __webpack_public_path__ + "images/b5fd360252b94224ebf028907004d511.svg";